<div class="modal-header">
  <h4 class="modal-title">JMESPath Evaluator</h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-jmes-path-evaluator [payload]="payload"></app-jmes-path-evaluator>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
</div>
